import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../../components/base.component';
import { environment } from '../../../environment';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
var DocSourcePhotoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocSourcePhotoComponent, _super);
    function DocSourcePhotoComponent(_vcr, documentService) {
        var _this = _super.call(this, _vcr) || this;
        _this.documentService = documentService;
        return _this;
    }
    Object.defineProperty(DocSourcePhotoComponent.prototype, "document", {
        get: function () {
            return this._document;
        },
        set: function (value) {
            if (window.environment.indexOf('internal') === -1 && value && value.url && value.url.indexOf('geosnap') > -1) {
                var url = value.url;
                value.url = environment.apiBaseUrl + url.substring(url.indexOf('geosnap') - 1, url.length);
            }
            this._document = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourcePhotoComponent.prototype, "currentFeature", {
        get: function () {
            return this._currentFeature;
        },
        set: function (value) {
            this._currentFeature = JSONConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourcePhotoComponent.prototype, "altText", {
        get: function () {
            return [this.document.title, this.document.description].filter(function (x) { return x; }).join(' - ') || 'Image';
        },
        enumerable: true,
        configurable: true
    });
    DocSourcePhotoComponent.prototype.requestLarger = function () {
        if (this.document) {
            this.documentService.requestFullScreenImages([this.document]);
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], DocSourcePhotoComponent.prototype, "currentFeature", null);
    return DocSourcePhotoComponent;
}(BaseComponent));
export { DocSourcePhotoComponent };
